window.wishlist = {


  init: () => {
    // console.log('init()');

    window.wishlist.addListeners();
    window.wishlist.updateButtonsData();
    window.wishlist.updateButtonsState();

    setTimeout(() => {
      window.wishlist.updateButtonsData();
      window.wishlist.updateButtonsState();
    }, 500);

    let tpl = document.body.getAttribute('data-tpl');
    if (tpl == 'page.wishlist') {
      window.wishlist.page.init();
    }

    clearInterval(window.wishlistAutoupdateLsInterval);
    window.wishlistAutoupdateLsInterval = setInterval(() => {
      window.wishlist.autoupdateLsInterval();
    }, 2000);
  },


  autoupdateLsInterval: () => {
    // console.log('autoupdateLsInterval()');

    let wishlist_ls_value = localStorage.getItem('wishlist'),
        wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
        current_time_in_ms = Date.now();
    
    if (wishlist_ls_array.length > 0) {
      for (let i = 0; i < wishlist_ls_array.length; i++) {
        let scheduled_update = parseFloat(wishlist_ls_array[i].details.scheduled_update)
        if (current_time_in_ms > scheduled_update) {
          // console.log(`i[${i}] need update`);

          fetch(`/products/${wishlist_ls_array[i].details.handle}`)
          .then(response => {
            if (response.ok) {
              return response.text();
            } else {
              console.log(response.status);
            };
          })
          .then(html => {
            let parser = new DOMParser()
                doc = parser.parseFromString(html, 'text/html');
                data_product_variants = doc.querySelector('[data-product-variants]');
            
            if (data_product_variants) {
              let data_product_variants_json = JSON.parse(data_product_variants.getAttribute('data-product-variants').replace(/'/g, '"'));
              for (let k = 0; k < data_product_variants_json.length; k++) {
                if (data_product_variants_json[k].id == wishlist_ls_array[i].item.id) {
                  wishlist_ls_array[i].details.price = data_product_variants_json[k].price;
                  wishlist_ls_array[i].details.available = data_product_variants_json[k].available;

                  if (data_product_variants_json[k].compare_at_price != null) {
                    wishlist_ls_array[i].details.compare_at_price = data_product_variants_json[k].compare_at_price;
                  }

                  let scheduled_update_time_in_ms = 1000 * 60 * 10; // 10 min
                  wishlist_ls_array[i].details.scheduled_update = Date.now() + scheduled_update_time_in_ms;

                  localStorage.setItem('wishlist', JSON.stringify(wishlist_ls_array));
                }
              }
            }
          })
          .catch(error => {
            console.log(error);
          });

          break;
        } 
      }
    } 
  },


  addListeners: () => {
    // console.log('addListeners()');

    let buttons_toggle_product_in_ls = document.querySelectorAll('.wishlist_icon[data-action="toggle_product_in_ls"]:not(.event_is_set)'),
        configurator_labels = document.querySelectorAll('.product-configurator__label'),
        pdp_inputs = document.querySelectorAll('.product-form__buy-buttons input')

    if (buttons_toggle_product_in_ls.length) {
      buttons_toggle_product_in_ls.forEach((button) => {
        button.addEventListener('click', () => {
          let data = JSON.parse(button.getAttribute('data-wishlist').replace(/'/g, '"'));
          window.wishlist.toggleProductInLs(data);
        });
        button.classList.add('event_is_set');
      });
    }

    if (pdp_inputs.length) {
      pdp_inputs.forEach(input => {
        input.addEventListener('change', () => {
          clearTimeout(window.wishlistTimeoutUpdateButtonsData);
          window.wishlistTimeoutUpdateButtonsData = setTimeout(()=> {
            window.wishlist.updateButtonsData();
          }, 100);
        });
      });
    }

    if (configurator_labels.length) {
      configurator_labels.forEach(input => {
        input.addEventListener('click', () => {
          clearTimeout(window.wishlistTimeoutUpdateButtonsData);
          window.wishlistTimeoutUpdateButtonsData = setTimeout(()=> {
            window.wishlist.updateButtonsData();
          }, 100);
        });
      });
    }

    if (!window.product_price_value) {
      window.checkProductPrice = setInterval(()=>{
        let product_price = document.querySelector('product-info .price-item--regular'),
            product_price_value = product_price ? parseFloat(product_price.innerHTML.replace(/\D/g,'')) : 0;
        
        if (!window.product_price_value) {
          window.product_price_value = product_price_value;
          window.wishlist.updateButtonsData();
        }

        if (product_price_value != window.product_price_value) {
          window.product_price_value = product_price_value;
          window.wishlist.updateButtonsData();
        }
      }, 1000);
    }

  },


  checkProductExistInLs: (_data) => {
    // console.log('checkProductExistInLs()');

    let wishlist_ls_value = localStorage.getItem('wishlist'),
        wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
        product_exist_in_ls = false;
    
    if (wishlist_ls_array.length > 0) {
      for (let i = 0; i < wishlist_ls_array.length; i++) {
        if (
          wishlist_ls_array[i].item.id == _data.item.id &&
          wishlist_ls_array[i].item.properties == _data.item.properties
        ) {
          product_exist_in_ls = true;
        }
      }
    } 
    
    return product_exist_in_ls;
  },


  toggleProductInLs: (_data) => {
    // console.log('toggleProductInLs()');

    let product_exist_in_ls = window.wishlist.checkProductExistInLs(_data);
    if (product_exist_in_ls == true) {
      window.wishlist.removeProductFromLs(_data);
    } else {
      window.wishlist.addProductToLs(_data);
    }
  },


  addProductToLs: (_data) => {
    // console.log('addProductToLs()');
    
    let scheduled_update_time_in_ms = 1000 * 60 * 10; // 10 min
    _data.details.scheduled_update = Date.now() + scheduled_update_time_in_ms;

    let wishlist_ls_value = localStorage.getItem('wishlist'),
        wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
        product_exist_in_ls = false,
        new_value = false;

    if (wishlist_ls_array.length == 0) {
      new_value = [_data];
    } else {
      for (let i = 0; i < wishlist_ls_array.length; i++) {
        if (
            wishlist_ls_array[i].item.id == _data.item.id &&
            wishlist_ls_array[i].item.properties == _data.item.properties
          ) {
          product_exist_in_ls = true;
        }
      }

      if (product_exist_in_ls == false) {
        new_value = wishlist_ls_array;
        new_value[wishlist_ls_array.length] = _data;
      }
    }

    if (new_value != false) {
      localStorage.setItem('wishlist', JSON.stringify(new_value));
    }

    window.wishlist.updateButtonsState();
  },


  removeProductFromLs: (_data) => {
    // console.log('removeProductFromLs()');
  
    let wishlist_ls_value = localStorage.getItem('wishlist'),
        wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
        product_exist_in_ls = false,
        new_value = [];

    for (let i = 0; i < wishlist_ls_array.length; i++) {
      if (
          wishlist_ls_array[i].item.id == _data.item.id &&
          JSON.stringify(wishlist_ls_array[i].item.properties) == JSON.stringify(_data.item.properties)
        ) {
        product_exist_in_ls = true;
      } else {
        new_value.push(wishlist_ls_array[i]);
      }
    }

    if (new_value.length == 0) {
      window.wishlist.removeLs();
    } else {
      localStorage.setItem('wishlist', JSON.stringify(new_value));
    }

    window.wishlist.updateButtonsState();
  },


  removeLs: () => {
    // console.log('removeLs');

    localStorage.removeItem('wishlist');
    wishlist.page.init();
  },


  updateButtonsState: () => {
    // console.log('updateButtonsState()');

    let buttons_toggle_product_in_ls = document.querySelectorAll('.wishlist_icon[data-action="toggle_product_in_ls"]'),
        button_header = document.querySelector('.wishlist_icon--header'),
        button_header_counter = button_header.querySelector('.wishlist_icon__counter');

    if (buttons_toggle_product_in_ls.length) {
      buttons_toggle_product_in_ls.forEach((button) => {
        window.wishlist.updateButtonState(button);
      });
    }

    if (button_header) {
      let wishlist_ls_value = localStorage.getItem('wishlist'),
          wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [];

      if (wishlist_ls_array.length > 0) {
        button_header_counter.innerHTML = wishlist_ls_array.length;
      } else {
        button_header_counter.innerHTML = '';
      }
    }
  },


  updateButtonState: (_button) => {
    // console.log('updateButtonState()');

    if (_button.getAttribute('data-wishlist')) {
      let data = JSON.parse(_button.getAttribute('data-wishlist').replace(/'/g, '"')),
          wishlist_ls_value = localStorage.getItem('wishlist'),
          wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
          product_exist_in_ls = false;

      for (let i = 0; i < wishlist_ls_array.length; i++) {
        if (
            wishlist_ls_array[i].item.id == data.item.id &&
            JSON.stringify(wishlist_ls_array[i].item.properties) == JSON.stringify(data.item.properties)
          ) {
          product_exist_in_ls = true;
        }
      }

      if (product_exist_in_ls == true) {
        _button.classList.add('is_active');
      } else {
        _button.classList.remove('is_active');
      }
    }
  },


  updateButtonsData: () => {
    // console.log('updateButtonsData()');        

    let tpl = document.body.getAttribute('data-tpl'),
        buttons_toggle_product_in_ls = document.querySelectorAll('.wishlist_icon[data-action="toggle_product_in_ls"]'),
        scheduled_update_time_in_ms = 1000 * 60 * 10; // 10 min

    if (tpl == 'product') {
      let input_product_variant_id = document.querySelector('input.product-variant-id'),
          input_size = document.querySelector('product-info input[name="Rozmiar"]:checked'),
          inputs_properties = document.querySelectorAll('[name^="properties["'),
          product_title = document.querySelector('.product__title h1').innerHTML,
          product_price = document.querySelector('product-info .price-item--regular'),
          product_price_value = product_price ? parseFloat(product_price.innerHTML.replace(/\D/g,'')) : 0,
          last_url = window.location.pathname + window.location.search;

      if (buttons_toggle_product_in_ls.length) {
        buttons_toggle_product_in_ls.forEach((button) => {
          let data = JSON.parse(button.getAttribute('data-wishlist').replace(/'/g, '"')),
              new_title = product_title;
          
          data.details.scheduled_update = Date.now() + scheduled_update_time_in_ms;
          data.details.last_url = last_url;
          data.details.price = product_price_value;

          if (input_product_variant_id) {
            data.item.id = parseFloat(input_product_variant_id.value);
          }

          if (input_size) {
            let input_size_value = input_size.value;
            new_title += ' - '+input_size_value;
          }

          data.details.title = new_title;

          if (inputs_properties.length) {
            let properties = {};

            inputs_properties.forEach((input) => {
              if (input.value != '') {
                let key = input.getAttribute('name').replace('properties[', '').replace(']', '');
                properties[key] = input.value;
              }
            });

            let first_prop_exist = Object.values(properties)[0] ? true : false;
            if (first_prop_exist) {
              data.item.properties = properties;
            }
          }

          let new_value = JSON.stringify(data).replace(/"/g, "'");
          button.setAttribute('data-wishlist', new_value);
        });
      }

      window.wishlist.updateButtonsState();
    }
  },


  page: {


    init: () => {
      // console.log('page.init()');

      window.wishlist.page.generateGrid();
      window.wishlist.page.addListeners();
    },


    addListeners: () => {
      // console.log('page.addListeners()');

      let buttons_add_to_cart = document.querySelectorAll('.card .wishlist_add_to_cart:not(.event_is_set)'),
          buttons_remove = document.querySelectorAll('.card .wishlist_remove:not(.event_is_set)');

      if (buttons_add_to_cart.length) {
        buttons_add_to_cart.forEach((button) => {
          button.addEventListener('click', () => {
            button.closest('.card').classList.add('is_loading');
            let data = JSON.parse(button.closest('.card').getAttribute('data-wishlist').replace(/'/g, '"')),
                form_data = {'items':[data.item]};
                
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(form_data)
            })
            .then(response => {
              if (response.status == 200) {
                button.closest('.card').classList.remove('is_loading');
                button.closest('.card').classList.add('added');
                window.wishlist.removeProductFromLs(data);
                window.wishlist.updateButtonsState();
                window.wishlist.updateHeaderCartIcon();

                setTimeout(()=>{
                  button.closest('.grid__item').remove();
                }, 3000, button)
              }
              return response.json();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          });

          button.classList.add('event_is_set');
        });
      }

      if (buttons_remove.length) {
        buttons_remove.forEach((button) => {
          button.addEventListener('click', () => {          
            let data = JSON.parse(button.closest('.card').getAttribute('data-wishlist').replace(/'/g, '"'));
            window.wishlist.removeProductFromLs(data);
            button.closest('.grid__item').remove();
          });

          button.classList.add('event_is_set');
        });
      }
    },


    generateGrid: () => {
      // console.log('page.generateGrid()');
    
      let wishlist_ls_value = localStorage.getItem('wishlist'),
          wishlist_ls_array = wishlist_ls_value != null ? JSON.parse(wishlist_ls_value) : [],
          html = '';
      
      if (wishlist_ls_array.length > 0) {

        for (let i = 0; i < wishlist_ls_array.length; i++) {

          let data_string = JSON.stringify(wishlist_ls_array[i]).replace(/"/g, "'"),
              wishlist_product_properties_html = '';

          if (wishlist_ls_array[i].item.properties) {
            wishlist_product_properties_html += '<ul>';

            for (let j = 0; j < Object.keys(wishlist_ls_array[i].item.properties).length; j++) {
              wishlist_product_properties_html += '<li>';
              wishlist_product_properties_html += '<span>' + Object.keys(wishlist_ls_array[i].item.properties)[j] +  ':</span> <span>' + Object.values(wishlist_ls_array[i].item.properties)[j]+ '</span>';
              wishlist_product_properties_html += '</li>';
            }

            wishlist_product_properties_html += '</ul>';
          }

          let data_product_available = wishlist_ls_array[i].details.available == true ? 1 : 0;

          html += `
            <li class="grid__item scroll-trigger animate--slide-in" data-cascade="" data-product-available="${data_product_available}" style="--animation-order: 1;">
              <div class="card-wrapper product-card-wrapper underline-links-hover">
                <div class="card card--standard card--media" style="--ratio-percent: 100.0%;" data-wishlist="${data_string}">
                  <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100.0%;">
                  `;

                  if (data_product_available == 0) {
                    html += `<div class="not_available">${window.t.wishlist.card.not_available}</div>`;
                  }
                  
                  html+= `
                    <div class="card__media">
                      <div class="media media--transparent media--hover-effect">
                        <img src="${wishlist_ls_array[i].details.image}">
                      </div>
                    </div>
                    <div class="card__content">
                      <div class="card__information">
                        <h3 class="card__heading">
                          <a href="${wishlist_ls_array[i].details.url}" id="StandardCardNoMediaLink-template--17011055198359__product-grid-8398088274071" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--17011055198359__product-grid-8398088274071 NoMediaStandardBadge-template--17011055198359__product-grid-8398088274071">
                          ${wishlist_ls_array[i].details.title}
                          </a>
                        </h3>
                      </div>
                      <div class="card__badge bottom left"></div>
                      <div class="card__added"><div></div></div>
                    </div>
                  </div>

                  <div class="card__content">
                    <div class="card__information">

                      <h3 class="card__heading h5" id="title-template--17011055198359__product-grid-8398088274071">
                        <a href="${wishlist_ls_array[i].details.url}" id="CardLink-template--17011055198359__product-grid-8398088274071" class="full-unstyled-link" aria-labelledby="CardLink-template--17011055198359__product-grid-8398088274071 Badge-template--17011055198359__product-grid-8398088274071">
                          ${wishlist_ls_array[i].details.title}
                        </a>
                      </h3>
                      
                      <div class="card-information"><span class="caption-large light"></span>
                        <div class="price ">
                          <div class="price__container">
                            <div class="price__regular s1">
                              <span class="visually-hidden visually-hidden--inline">Cena regularna</span>
                              <span class="price-item price-item--regular">
                                ${(wishlist_ls_array[i].details.price)/100} ${wishlist_ls_array[i].details.currency}
                              </span>
                            </div>
                            <div class="price__sale">
                              <span class="visually-hidden visually-hidden--inline">Cena regularna</span>
                              <span>
                                <s class="price-item price-item--regular">
                                </s>
                              </span>
                              <span class="visually-hidden visually-hidden--inline">Cena promocyjna</span>
                              <span class="price-item price-item--sale price-item--last">
                                0,00 PLN
                              </span>
                            </div>
                            <small class="unit-price caption hidden">
                              <span class="visually-hidden">Cena jednostkowa</span>
                              <span class="price-item price-item--last">
                                <span></span>
                                <span aria-hidden="true">/</span>
                                <span class="visually-hidden">&nbsp;na&nbsp;</span>
                                <span>
                                </span>
                              </span>
                            </small>
                          </div>
                        </div>
                      </div>

                      <div class="wishlist_icon wishlist_icon--card event_is_set is_active" data-action="toggle_product_in_ls">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path class="state_default svgfill" d="M12.0016 20L10.9766 19.0757C9.43732 17.6749 8.16441 16.4711 7.15785 15.4644C6.15131 14.4577 5.3537 13.5617 4.76502 12.7765C4.17632 11.9913 3.76501 11.2751 3.53108 10.6279C3.29714 9.98059 3.18018 9.32378 3.18018 8.65741C3.18018 7.33543 3.62452 6.2287 4.51321 5.33722C5.4019 4.44574 6.50517 4 7.82301 4C8.63373 4 9.3998 4.19019 10.1212 4.57056C10.8426 4.95092 11.4694 5.49637 12.0016 6.20692C12.5337 5.49637 13.1605 4.95092 13.8819 4.57056C14.6034 4.19019 15.3694 4 16.1802 4C17.498 4 18.6013 4.44574 19.49 5.33722C20.3786 6.2287 20.823 7.33543 20.823 8.65741C20.823 9.32378 20.706 9.98059 20.4721 10.6279C20.2382 11.2751 19.8269 11.9913 19.2382 12.7765C18.6495 13.5617 17.8533 14.4577 16.8498 15.4644C15.8462 16.4711 14.5718 17.6749 13.0266 19.0757L12.0016 20ZM12.0016 18.112C13.4873 16.7709 14.7099 15.6215 15.6694 14.6637C16.629 13.7059 17.3873 12.8739 17.9444 12.1675C18.5016 11.4611 18.8885 10.8339 19.1052 10.2857C19.3218 9.73757 19.4302 9.1948 19.4302 8.65741C19.4302 7.72592 19.1206 6.94968 18.5016 6.32869C17.8825 5.7077 17.1087 5.39721 16.1802 5.39721C15.4468 5.39721 14.7691 5.6059 14.1471 6.02328C13.5251 6.44065 13.0325 7.02134 12.6694 7.76535H11.3337C10.9647 7.01538 10.4706 6.43319 9.85159 6.01879C9.23254 5.6044 8.55635 5.39721 7.82301 5.39721C6.9004 5.39721 6.12807 5.7077 5.50604 6.32869C4.88402 6.94968 4.57301 7.72592 4.57301 8.65741C4.57301 9.1948 4.68134 9.73757 4.89801 10.2857C5.11468 10.8339 5.50158 11.4611 6.05872 12.1675C6.61587 12.8739 7.3742 13.7045 8.33372 14.6592C9.29325 15.614 10.5159 16.7649 12.0016 18.112Z" fill="#353535"></path>
                          <path class="state_active svgfill" d="M12.0016 20L10.9766 19.0757C9.43732 17.6749 8.16441 16.4711 7.15785 15.4644C6.15131 14.4577 5.3537 13.5617 4.76502 12.7765C4.17632 11.9913 3.76501 11.2751 3.53108 10.6279C3.29714 9.98059 3.18018 9.32378 3.18018 8.65741C3.18018 7.33543 3.62452 6.2287 4.51321 5.33722C5.4019 4.44574 6.50517 4 7.82301 4C8.63373 4 9.3998 4.19019 10.1212 4.57056C10.8426 4.95092 11.4694 5.49637 12.0016 6.20692C12.5337 5.49637 13.1605 4.95092 13.8819 4.57056C14.6034 4.19019 15.3694 4 16.1802 4C17.498 4 18.6013 4.44574 19.49 5.33722C20.3786 6.2287 20.823 7.33543 20.823 8.65741C20.823 9.32378 20.706 9.98059 20.4721 10.6279C20.2382 11.2751 19.8269 11.9913 19.2382 12.7765C18.6495 13.5617 17.8533 14.4577 16.8498 15.4644C15.8462 16.4711 14.5718 17.6749 13.0266 19.0757L12.0016 20Z" fill="#353535"></path>
                        </svg>
                      </div>
                      <div class="wishlist_product_properties">${wishlist_product_properties_html}</div>
                      <div class="wishlist_card_buttons">`;
                        if (data_product_available == 1) {
                          html += `<div class="wishlist_add_to_cart">${window.t.wishlist.buttons.add_to_cart}</div>`;
                        }
                        html += `<div class="wishlist_remove">${window.t.wishlist.buttons.remove_from_wishlist}</div>
                      </div>
                    </div>
                    <div class="card__badge bottom left"></div>
                  </div>
                
                </div>
              </div>
            </li>
          `;
        }

      } else {
        let empty_info = document.querySelector('.wishlist-page-empty-info');
        if (empty_info) {
          empty_info.classList.add('is_active');
        }
      }

      let grid = document.querySelector('#product-grid');
      if( grid ) {
        grid.innerHTML = html;
      };
    }
  },


  updateHeaderCartIcon: () => {
    // console.log('updateHeaderCartIcon()');

    let cart_counter = document.querySelector('.header__icon--cart .cart-count-bubble');
    if (cart_counter) {
      fetch(`/`)
      .then(response => {
        if (response.ok) {
          return response.text();
        }
      })
      .then(html => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        let item = doc.querySelector('.header__icon--cart .cart-count-bubble');
        
        if (item) {
          cart_counter.innerHTML = item.innerHTML;
        }
      })
      .catch(error => {
        console.log(error);
      });
    }
  }


};

window.wishlist.init();
